"use client";

import { useEffect, useState } from "react";

import {
  applyKnopkaBookingPageAppearance,
  clearKnopkaBookingPageAppearance,
  emptyBookingPageAppearance,
  parseBookingPageAppearance,
  type KnopkaBookingPageAppearance,
} from "./knopkaBookingPageAppearance";

export function useKnopkaBookingPageAppearance(username: string | null | undefined) {
  const [appearance, setAppearanceState] = useState<KnopkaBookingPageAppearance>(emptyBookingPageAppearance());

  useEffect(() => {
    const pageUsername = username?.trim().toLowerCase() || null;
    if (!pageUsername) {
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(
          `/api/knopka/page-appearance/public?username=${encodeURIComponent(pageUsername)}`
        );
        if (!response.ok) return;
        const data = await response.json();
        if (cancelled) return;
        const next = parseBookingPageAppearance(data);
        setAppearanceState(next);
        applyKnopkaBookingPageAppearance(next);
      } catch {
        // Keep default appearance on network errors.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [username]);

  useEffect(() => {
    if (!username?.trim()) return;
    applyKnopkaBookingPageAppearance(appearance);
  }, [appearance, username]);

  const setAppearance = (next: KnopkaBookingPageAppearance) => {
    setAppearanceState(next);
    applyKnopkaBookingPageAppearance(next);
  };

  return { appearance, setAppearance };
}

export function clearKnopkaBookingPageAppearanceOnUnmount(username: string | null | undefined) {
  useEffect(() => {
    return () => {
      if (username?.trim()) {
        clearKnopkaBookingPageAppearance();
      }
    };
  }, [username]);
}
